<template>
	<v-dialog v-model="showDialog" persistent scrollable width="600px">
		<v-card>
			<v-card-title> Manage views </v-card-title>

			<v-card-text>
				<v-simple-table>
					<template #default>
						<thead>
							<tr>
								<th>View name</th>
								<th class="text-right">Set as Default</th>
								<th v-if="showGlobalColumn" class="text-right">
									Global View
								</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="viewsList.length === 0">
								<td>No views available</td>
							</tr>
							<tr v-for="view in viewsList" :key="view.Id">
								<td>
									{{ view.Name }}
									<v-chip
										v-if="view.IsGlobal"
										x-small
										class="ml-2"
										color="primary"
										outlined
									>
										Global
									</v-chip>
								</td>
								<td class="text-right">
									<v-switch
										v-if="view.UserId != null"
										v-model="view.IsDefault"
										class="ma-0 pa-0 float-right"
										color="primary"
										@change="onIsDefaultChanged(view)"
									/>
								</td>
								<td v-if="showGlobalColumn" class="text-right">
									<v-switch
										v-if="canToggleGlobal(view)"
										v-model="view.IsGlobal"
										class="ma-0 pa-0 float-right"
										color="primary"
										@change="onIsGlobalChanged(view)"
									/>
								</td>
								<td class="d-flex align-center justify-end">
									<v-btn
										v-if="canDeleteView(view)"
										small
										icon
										elevation="1"
										class="action-btn"
										color="red"
										@click="deleteView(view)"
									>
										<v-icon>mdi-delete</v-icon>
									</v-btn>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-btn text outlined @click="close"> Close </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import permissionsMixin from '../../../mixins/permissionsMixin';
import gridViewOwnerMixin from '../../../mixins/grids/gridViewOwnerMixin';
export default {
	name: 'ManageViewsDialog',
	mixins: [permissionsMixin, gridViewOwnerMixin],
	props: {
		showDialog: Boolean,
		deleteViewAction: String,
		setDefaultViewAction: String,
		setGlobalViewAction: String,
		//Data grids and Inventory Form grids each have their own global view permission, they pass
		//it in. A grid that leaves it out keeps the plain "my own view" behaviour.
		globalViewPermission: String,
		viewsList: Array,
	},
	computed: {
		/**
		 * The column only makes sense for a user who can actually share a view, everybody else
		 * still recognizes a global view by the chip next to its name.
		 */
		showGlobalColumn() {
			if (!this.globalViewPermission) return false;
			return this.hasPermissions([this.globalViewPermission]);
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		//the base view of the grid (UserId == null) is never deletable
		canDeleteView(view) {
			return this.isViewOwner(view);
		},
		//sharing a view, or taking it back, is the owner's call and needs the global view permission
		canToggleGlobal(view) {
			if (!this.showGlobalColumn) return false;
			return this.isViewOwner(view);
		},
		onIsDefaultChanged(view) {
			this.$store.dispatch(this.setDefaultViewAction, view);
		},
		onIsGlobalChanged(view) {
			if (!this.setGlobalViewAction) return;
			this.$store
				.dispatch(this.setGlobalViewAction, view)
				//the switch already moved, put it back when the server refused the change
				.then((success) => {
					if (!success) view.IsGlobal = !view.IsGlobal;
				});
		},
		deleteView(view) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this view?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(this.deleteViewAction, view);
			});
		},
	},
};
</script>

<style lang="scss">
.v-input--switch {
	.v-input__slot {
		margin-bottom: 0;
	}
	.v-messages {
		display: none;
	}
}
</style>
